import { LOAD_NUMBER } from 'config'
import { Post, PaginationResult } from 'lib/_types'
import { pathApiHighlight, pathApiHighlights } from 'lib/paths'

import { yayApi } from '../baseApi'

export const highlightApi = yayApi
  .enhanceEndpoints({
    addTagTypes: ['Highlights', 'Group/Base'],
  })
  .injectEndpoints({
    endpoints: (build) => ({
      getHighlights: build.query<
        PaginationResult<Post>,
        {
          groupId: string
          from: string
        }
      >({
        keepUnusedDataFor: 0,
        query: ({ groupId, from }) => ({
          url: pathApiHighlights({ groupId }),
          params: {
            group_id: groupId,
            number: LOAD_NUMBER,
            ...(from == '0'
              ? {}
              : {
                  from,
                }),
          },
        }),
        transformResponse(baseQueryReturnValue: {
          posts: Array<Post>
          next_page_value: number
        }) {
          return {
            list: baseQueryReturnValue?.posts ?? [],
            next_page_value: baseQueryReturnValue?.next_page_value,
          }
        },
      }),

      addHighlight: build.mutation<any, { groupId: string; id: number }>({
        invalidatesTags: ['Highlights', 'Group/Base'],
        query: ({ groupId, id }) => ({
          url: pathApiHighlight({ groupId, id }),
          method: 'PUT',
        }),
      }),

      removeHighlight: build.mutation<any, { groupId: string; id: number }>({
        invalidatesTags: ['Highlights', 'Group/Base'],
        query: ({ groupId, id }) => ({
          url: pathApiHighlight({ groupId, id }),
          method: 'DELETE',
        }),
      }),
    }),
    overrideExisting: false,
  })

export const {
  endpoints,
  useGetHighlightsQuery,
  useAddHighlightMutation,
  useRemoveHighlightMutation,
} = highlightApi
